import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Form from "../../../Utils/Form/Formik";
import { updateuserdata } from "../../../Services/Admin/Addmin";
import { getUserdata } from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";
const mcxSymbols = [
  "NATGASMINI",
  "SILVERM",
  "GOLDM",
  "SILVER",
  "GOLD",
  "COPPER",
  "CRUDEOIL",
  "CRUDEOILM",
  "NATURALGAS",
  "ZINC",
];
const Updateuser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const TokenData = getUserFromToken();
const permissions = JSON.parse(localStorage.getItem("market") || "[]");
  const { rowData } = location.state;
  const [data, setData] = useState([]);
  const user_id = TokenData?.user_id;

  useEffect(() => {
    getAlluserdata();
  }, []);

  const formik = useFormik({
    initialValues: {
      fullName: "",
      username: "",
      email: "",
      phone: "",
      employee_id: "",

      limit: "1",
      holding_limit: "1",
      option_selling_limit: "1",
      selectedOption: "",
      inputValue: "",
      market: [],
      price_zero_status: false,
      hide_sell_button: false,
      option_status: false,
      tradeType: 0,
      trade_block_time: "",
  mcxData: {},        
      mcxEnabled: false, 

    },
    validate: (values) => {
      let errors = {};
      if (!values.fullName) errors.fullName = "Please Enter Full Name";
      if (!values.username) errors.username = "Please Enter Username";
      if (!values.email) {
        errors.email = "Please Enter Email Address";
      } else if (!/^\S+@\S+\.\S+$/.test(values.email)) {
        errors.email = "Please enter a valid email address.";
      }
      if (!values.phone) {
        errors.phone = "Please Enter Phone Number";
      }
      if (!values.limit) {
        errors.limit = "Please enter a value for Limit";
      } else if (
        isNaN(values.limit) ||
        values.limit < 0 ||
        values.limit > 10000
      ) {
        errors.limit = "Limit must be a number between 0 and 10000.";
      }

      if (!values.holding_limit) {
        errors.holding_limit = "Please enter a value for HOLDING limit";
      } else if (
        isNaN(values.holding_limit) ||
        values.holding_limit < 0 ||
        values.holding_limit > 10000
      ) {
        errors.holding_limit =
          "HOLDING limit must be a number between 0 and 10000.";
      }

      if (!values.selectedOption)
        errors.selectedOption = "Please select an option";
      if (!values.inputValue)
        errors.inputValue = "Please enter a value for the selected option";

      if (values.market.length === 0) {
        errors.market = "Please select at least one market";
      }

      return errors;
    },
    onSubmit: async (values, { setSubmitting }) => {
      const selectedOption = values.selectedOption;
      const data = {
        id: rowData && rowData._id,
        limit: values.limit,
        holding_limit: values.holding_limit || "1",
        employee_id: values.employee_id,
        option_selling_limit: values.option_selling_limit || "1",
        [selectedOption]: values.inputValue,
        market: values.market,
        mcx: values.market.includes(1) ? values.mcxData : {},
        option_selling_permission: values.option_selling_permission,
        price_zero_status: values.price_zero_status,
        option_status: values.option_status ? 1 : 0,
        hide_sell_button: values.hide_sell_button,
        tradeType: values.tradeType,
        // trade_block_time: values.trade_block_time,
        trade_block_time: String(values.trade_block_time || ""),

      };
      setSubmitting(false);
      try {
        const response = await updateuserdata(data);
        if (response.status) {
          Swal.fire({
            title: "User Updated!",
            text: "User updated successfully",
            icon: "success",
            timer: 2000,
            timerProgressBar: true,
          });
          setTimeout(() => {
            navigate("/admin/users");
          }, 2000);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.message || "User update error",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to update user. Please try again later.",
          icon: "error",
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },
  });

  useEffect(() => {
    if (rowData) {
      const determineSelectedOption = () => {
        if (rowData.pertrade && rowData.pertrade !== 0) return "pertrade";
        if (rowData.perlot && rowData.perlot !== 0) return "perlot";
        return "transactionwise";
      };

      formik.setValues({
        fullName: rowData.FullName || "",
        username: rowData.UserName || "",
        email: rowData.Email || "",
        phone: rowData.PhoneNo || "",
        Password: rowData.Otp || "",
        employee_id: rowData.employee_id || "",

        selectedOption: determineSelectedOption(),
        inputValue:
          rowData.pertrade || rowData.perlot || rowData.transactionwise || "",
        limit: rowData.limit || "1",
        holding_limit: rowData.holding_limit || "1",
        option_selling_limit: rowData.option_selling_limit || "1",
        market: rowData.market || [],
        mcxData: rowData.mcx || {},
        mcxEnabled: rowData.market?.includes(1) ? true : false,
        option_selling_permission: rowData.option_selling_permission || false,
        price_zero_status: rowData.price_zero_status || false,
        hide_sell_button: rowData.hide_sell_button || false,
        option_status: rowData.option_status === 1 ? true : false,
        tradeType: rowData.tradeType || 0,
       trade_block_time: String(rowData.trade_block_time || "")?.replace(/[^0-9:]/g, ""),


      });
    }
  }, [rowData]);

  
    useEffect(() => {
      if (formik.values.market.includes(1)) {
        formik.setFieldValue("mcxEnabled", true);
      } else {
        formik.setFieldValue("mcxEnabled", false);
      }
    }, [formik.values.market]);

  const getInputValueLabel = (selectedOption) => {
    if (selectedOption === "pertrade") return "Enter Value for Per Trade";
    if (selectedOption === "perlot") return "Enter Value for Per Lot";
    if (selectedOption === "transtationwise") return "Enter Value for transtationwise";
    return "Enter Value";
  };

  const getAlluserdata = async () => {
    const data = { id: user_id };
    try {
      const response = await getUserdata(data);
      const result =
        response.data &&
        response.data.filter((item) => item.Role === "EMPLOYE");
      setData(result);
    } catch (error) { }
  };

  const fields = [
      { type: "heading", label: "Update Basic Details", col_size: 12 },
    {
      name: "fullName",
      label: "Full Name",
      type: "text",
      label_size: 6,
      col_size: 6,
      disable: true,
    },
    {
      name: "username",
      label: "Username",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: true,
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: true,
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "text3",
      label_size: 12,
      col_size: 6,
      disable: true,
    },
    {
      name: "Password",
      label: "Password",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: true,
    },
    {
      name: "employee_id",
      label: "Employee",
      type: "select",
      options: [
        { label: "Admin", value: "Admin" },
        ...(data
          ? data.map((item) => ({ label: item.UserName, value: item._id }))
          : []),
      ],
      label_size: 12,
      col_size: 6,
    },
    {
      name: "holding_limit",
      label: "HOLDING Margin",
      type: "percentage",
      label_size: 12,
      col_size: 6,
      min: 0,
      max: 12,
    },
    {
      name: "limit",
      label: "INTRADAY Margin",
      type: "percentage",
      label_size: 12,
      col_size: 6,
      min: 0,
      max: 12,
    },
    {
      name: "option_selling_limit",
      label: "OPTION SELLING Margin",
      type: "percentage",
      label_size: 12,
      col_size: 6,
      min: 0,
      max: 12,
    },
    {
      name: "selectedOption",
      label: "Select One Option",
      type: "select",
      options: [
        { value: "pertrade", label: "Per Trade" },
        { value: "perlot", label: "Per Lot" },
        { value: "transactionwise", label: "transtation wise" }
      ],
      label_size: 12,
      col_size: 6,
    },
    {
      name: "inputValue",
      label: getInputValueLabel(formik.values.selectedOption),
      type: "text",
      label_size: 12,
      col_size: 6,
      showWhen: (values) => !!values.selectedOption,
    },
    {
      name: "tradeType",
      label: "Client Trade Type",
      type: "select",
      options: [
        { value: 0, label: "Fund Wise" },
        { value: 1, label: "Per Trade" },
      ],
      label_size: 12,
      col_size: 6,
    },

    
  { type: "heading", label: " Trade Block Duration  &  Select Markets", col_size: 12 },

    {
  name: "market_ui",
  type: "custom",
  col_size: 12,
},

      { type: "heading", label: "Update Permission", col_size: 12 },
    ...(formik.values.market.includes(0)
  ? [
      {
        name: "option_selling_permission",
        label: "Forex Option Selling Permission",
        type: "toggle",
        col_size: 6,
        label_size: 12,
      },
      {
        name: "option_status",
        label: "Forex Option Chain Price Zero Permission",
        type: "toggle",
        col_size: 6,
        label_size: 12,
      },
    ]
  : []),

...(formik.values.market.includes(1)
  ? [
      {
        name: "hide_sell_button",
        label: "INR Option Selling Permission",
        type: "toggle",
        col_size: 6,
        label_size: 12,
      },
      {
        name: "price_zero_status",
        label: "INR Option Chain Price Zero Permission",
        type: "toggle",
        col_size: 6,
        label_size: 12,
      },
    ]
  : []),

  ];

  return (
    <Form
      fields={fields}
      page_title="Update User"
      btn_name="Update User"
      btn_name1="Cancel"
      formik={formik}
       TokenData={TokenData}       
  mcxSymbols={mcxSymbols}      
    rowData={rowData} 
      btn_name1_route={"/admin/users"}

//       additional_field={<div className="col-lg-12 ">
//         <div className="mb-3">
//           <label className="fw-bold">Trade Block Duration</label>
//           <input
//             type="text"
//             className="form-control "
//             placeholder="mm:ss"
//             value={formik.values.trade_block_time || ""}
//             onChange={(e) => {
//               let value = e.target.value;

//               // Auto-format only mm:ss allowed
//               if (/^[0-9]{0,2}(:[0-9]{0,2})?$/.test(value)) {
//                 formik.setFieldValue("trade_block_time", value);
//               }
//             }}
//           />
//           <small className="text-muted">Format: mm:ss (Example: 05:30)</small>
//         </div>

//         <label className="fw-bold mb-2">Select Markets</label>
//         <div className="d-flex gap-4 align-items-center">
//           {/* Forex */}
//           {TokenData?.market.includes(0) && <div className="form-check">
//             <input
//               type="checkbox"
//               className="form-check-input"
//               id="market-forex"
//               checked={formik.values.market.includes(0)}
//               disabled={rowData?.market?.includes(0)}
//               onChange={(e) => {
//                 if (e.target.checked) {
//                   formik.setFieldValue("market", [...formik.values.market, 0]);
//                 } else {
//                   formik.setFieldValue("market", formik.values.market.filter((m) => m !== 0));
//                 }
//               }}
//             />
//             <label className="form-check-label fw-semibold" htmlFor="market-forex">Forex</label>
//           </div>}

//           {/* India */}
//           {TokenData?.market.includes(1) && (
//             <div className="form-check">
//               <input
//                 type="checkbox"
//                 className="form-check-input"
//                 id="market-india"
//                 checked={formik.values.market.includes(1)}
//                 disabled={rowData?.market?.includes(1)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     formik.setFieldValue("market", [
//                       ...formik.values.market,
//                       1,
//                     ]);
//                   } else {
//                     formik.setFieldValue(
//                       "market",
//                       formik.values.market.filter((m) => m !== 1)
//                     );
//                   }
//                 }}
//               />
//               <label
//                 className="form-check-label fw-semibold"
//                 htmlFor="market-india"
//               >
//                 India
//               </label>
//             </div>
//           )}
//         </div>

//         {formik.errors.market && (
//           <div className="text-danger mt-2 small">{formik.errors.market}</div>
//         )}


//  {/* MCX SECTION – sirf India ke liye */}
//         {formik.values.market.includes(1) && (
//           <>
//             <div className="mt-3">
//               <button
//                 type="button"
//                 className="btn btn-primary btn-sm"
//                 onClick={() =>
//                   formik.setFieldValue("mcxEnabled", !formik.values.mcxEnabled)
//                 }
//               >
//                 Add MCX Symbols
//               </button>
//             </div>

//             {formik.values.mcxEnabled && (
//               <div className="row mt-4">
//                 <div className="col-12">
//                   <div className="p-3 rounded shadow">
//                     <h6 className="fw-bold mb-3">MCX Symbols</h6>

//                     <div className="row">
//                       {mcxSymbols.map((symbol) => (
//                         <div key={symbol} className="col-md-4 mb-3">
//                           <label className="form-label fw-semibold">
//                             {symbol}
//                           </label>

//                           <input 
//                             type="number"
//                             className="form-control"
//                             value={formik.values.mcxData?.[symbol] || ""}
//                             onChange={(e) => {
//                               formik.setFieldValue("mcxData", {
//                                 ...formik.values.mcxData,
//                                 [symbol]: e.target.value,
//                               });
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>

//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}

//       </div>

//       }

    />
  );
};

export default Updateuser;
